import { createFileRoute } from '@tanstack/react-router'
import SulaleSorgu from '@/modules/musteriler'

export const Route = createFileRoute('/_authenticated/musteriler/')({
  component: SulaleSorgu,
}) 